@import (reference) '../../../constants/spacing.module.less';

.verification-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: @space-8;
}
